import { render, staticRenderFns } from "./resumoCard.vue?vue&type=template&id=2dac326b"
import script from "./resumoCard.vue?vue&type=script&lang=js"
export * from "./resumoCard.vue?vue&type=script&lang=js"
import style0 from "./resumoCard.vue?vue&type=style&index=0&id=2dac326b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports